import {
  GO_TO_LEVEL,
  NEXT_LEVEL,
  PREV_LEVEL,
  ANCHOR_TO,
  TOGGLE_VISIBILITY,
  SET_HTML,
  TOGGLE_SELF_CONTAINED_MODE,
  REPLACE_PALETTE,
} from './action_type';

export const initialState = {
  html: '',
  highlighters: [
    { hlColor: 'rgba(5, 163, 116, 0.4)' },
    { hlColor: 'rgba(98, 181, 3, 0.4)' },
    { hlColor: 'rgba(249, 249, 6, 0.4)' },
  ],
  visibility: true,
  level: 0,
  offset: 0,
  anchor: null,
  isSelfContained: false,
  left: false,
  prev: null,
  help: true,
  brand: true,
  viewer_class: false,
  navigation: false,
};

const record = state => nextProps => ({
  ...nextProps,
  prev: state,
});

function goToLevel(state, level) {
  return {
    ...state,
    level:
      (level > state.highlighters.length || level < 0) ? state.level : level,
  };
}

function handleAnchor(state, anchor, offset) {
  return {
    ...state,
    anchor,
    offset,
  };
}

function handleToggleVisibility(state, visibility) {
  return {
    ...state,
    visibility,
  };
}

function handleSetHTML(state, html) {
  return {
    ...state,
    html,
  };
}

function handleToggleSelfContainedMode(state, isSelfContained) {
  return {
    ...state,
    isSelfContained,
    anchor: null,
    offset: 0,
  };
}

function replaceHighlighters(state, highlighters) {
  return {
    ...state,
    highlighters,
  };
}

function kjuicerReducer(state = initialState, action) {
  const trackPrevState = record(state);
  switch (action.type) {
    case GO_TO_LEVEL:
      return trackPrevState(goToLevel(state, action.level));
    case NEXT_LEVEL:
      return trackPrevState(goToLevel(state, state.level + 1));
    case PREV_LEVEL:
      return trackPrevState(goToLevel(state, state.level - 1));
    case ANCHOR_TO:
      return trackPrevState(handleAnchor(state, action.node, action.offset));
    case TOGGLE_VISIBILITY:
      return trackPrevState(handleToggleVisibility(state, !state.visibility));
    case SET_HTML:
      return trackPrevState(handleSetHTML(state, action.html));
    case TOGGLE_SELF_CONTAINED_MODE:
      return trackPrevState(handleToggleSelfContainedMode(state, !state.isSelfContained));
    case REPLACE_PALETTE:
      return trackPrevState(replaceHighlighters(state, action.highlighters));
    default:
      return state;
  }
}

export default kjuicerReducer;
